import commonSlice from '@/state/common.slice';
import store from '@/state/store';
import { FeatureParams } from '@bimdata/definitions/types';

export default (features: Record<string, FeatureParams>) => {
  store.dispatch(commonSlice.actions.setFeatures(features));
};